import gql from 'graphql-tag'

export const SOCIAL_MENU_QUERY = gql`
query {
  menusMenus(filters: { slug: { contains: "social" } }) {
    data {
      id
      attributes {
        title
        slug
        items {
          data {
            id
            attributes {
              title
              target
              url
            }
          }
        }
      }
    }
  }
}
`;
